module.exports = __webpack_public_path__ + "img/PL08147.909c3108.png";